import React, { useState, useRef, useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

const SelectInput = ({
  options,
  name,
  placeholder = "Select...",
  onSelect,
  onChange,
  defaultValue,
  value,
  className,
  inputClassName
}) => {
  const [inputValue, setInputValue] = useState(defaultValue);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const containerRef = useRef(null);

  const filteredOptions = options.filter(option =>
    option?.toLowerCase()?.includes(inputValue?.toLowerCase())
  );

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    setDropdownOpen(true);
    if (onChange) onChange(e);
  };

  const handleSelectOption = (option) => {
    setInputValue(option);
    setDropdownOpen(false);
    if (onSelect) onSelect(option);
  };

  // Close dropdown if clicking outside the container
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef?.current && !containerRef?.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setInputValue(value)
  }, [value])

  return (
    <div ref={containerRef} className={twMerge("relative w-full", className)}>
      <input
        name={name}
        type="text"
        placeholder={placeholder}
        value={inputValue || ""}
        onChange={handleInputChange}
        onFocus={() => setDropdownOpen(true)}
        className={twMerge("input input-bordered w-full", inputClassName)}
      />
      {isDropdownOpen && filteredOptions.length > 0 && (
        <ul className="absolute z-10 mt-1 w-full bg-base-100 border border-base-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {filteredOptions.map((option, index) => (
            <li
              key={index}
              onMouseDown={() => handleSelectOption(option)}
              className="px-4 py-2 cursor-pointer hover:bg-base-200"
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectInput;
